import { Component, ViewEncapsulation, inject } from '@angular/core';
import { ModalService } from '../../../core/services/modal.service';
import { FirebaseService } from '../../../core/services/firebase.service';

import { RouterLink } from '@angular/router';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { OrderOnlineComponent } from '../../ordering/order-online.component';


@Component({
    selector: 'app-gallery-home-top',
    templateUrl: './gallery-home-top.component.html',
    styleUrls: ['./gallery-home-top.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterLink, ModalComponent, OrderOnlineComponent]
})


export class GalleryHomeTopComponent {
  private modalService = inject(ModalService);
  private firebaseService = inject(FirebaseService);


  showTopText = false;
  isAvailable = false;

  openOrderModal(id: string){
    this.modalService.open(id);
  }
  closeModal(id: string){
    this.modalService.close(id);
  }
  
  goToBookTable(){
    this.firebaseService.setViewPort('book-table');
  }

  mouseEnter(_e: unknown){
    this.firebaseService.setFloatButton(false);
  }


}

